// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"2b4c6e9f","37":"03a34970","158":"93c42f56","237":"f0dc15ad","449":"1a297c25","652":"7d6fc88d","672":"b7f7d7f3","718":"104bb639","769":"7bafe8f7"}[chunkId] + ".chunk.js";
};